export interface AppPageLayoutProps {
  children: React.ReactNode;
  /**
   * Use a fill viewport layout without document scroll (deck builder, drafter).
   * Default is a scrollable main area; footer lives only on the home page (MainContent).
   */
  fillViewport?: boolean;
}

/**
 * Standard shell for feature routes below the header.
 */
export function AppPageLayout({ children, fillViewport = false }: AppPageLayoutProps) {
  if (fillViewport) {
    return (
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <div className="min-h-0 min-w-0 flex-1 overflow-hidden">{children}</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto">{children}</div>
    </div>
  );
}
